module.exports = __webpack_public_path__ + "assets/img/arrow_right_no.6ad81a08.png";